import React from 'react'
import {Box, GlobalHeaderMenu} from '@fuegokit/react'
import {AkOpenIcon, AkChevronDownIcon} from '@fuegokit/fuegoicons-react'

const StyledDropdownExample = () => {
  return (
    <Box>
      <GlobalHeaderMenu>
        <GlobalHeaderMenu.Trigger>
          Reporting
          <AkChevronDownIcon />
        </GlobalHeaderMenu.Trigger>
        <GlobalHeaderMenu.Portal>
          <GlobalHeaderMenu.Content sideOffset={10}>
            <GlobalHeaderMenu.Item onSelect={() => alert("navigate to my application's SPA route")}>
              Option 1
            </GlobalHeaderMenu.Item>
            <GlobalHeaderMenu.Item
              description={`This is a description`}
              onSelect={() => alert("navigate to my application's SPA route")}
            >
              Option 2
            </GlobalHeaderMenu.Item>
            <GlobalHeaderMenu.Item onSelect={() => alert("navigate to my application's SPA route")}>
              Option 3
            </GlobalHeaderMenu.Item>
            <GlobalHeaderMenu.Item disabled description={`This item is disabled`}>
              Disabled
            </GlobalHeaderMenu.Item>
            <GlobalHeaderMenu.Item onSelect={() => window.open('https://www.google.com', '_blank', 'noreferrer')}>
              <Box sx={{display: 'flex', alignItems: 'center'}}>
                Navigate to a site <AkOpenIcon />
              </Box>
            </GlobalHeaderMenu.Item>
            <GlobalHeaderMenu.Item onSelect={() => alert("navigate to my application's SPA route")}>
              Option 6
            </GlobalHeaderMenu.Item>
          </GlobalHeaderMenu.Content>
        </GlobalHeaderMenu.Portal>
      </GlobalHeaderMenu>
    </Box>
  )
}
export default StyledDropdownExample
